<template>
    <v-container fluid>
        <v-form v-model="isFormValid">
            <v-card>
                <v-card-title>
                    <v-container>
                        <v-row>
                            <v-col :cols="12">{{ title }}</v-col>
                        </v-row>

                        <parameters :parameters="parameters" />

                        <v-row>
                            <v-col>
                                <v-btn v-on:click="runQuery" :disabled="!isFormValid">Build Report</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-title>

                <v-card-text>
                    <report-table :items="items" :headers="headers" :query-loading="queryLoading" :title="title" />
                </v-card-text>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import errorUtility from '../services/errorUtility'
    import { DateTime } from 'luxon'

    export default {
        components: {
            reportTable: () => import('../reports/ReportTable'),
            parameters: () => import('../reports/Parameters')
        },

        async mounted() {
            var response = await axios.get('api/RegionTypes');
            var regionTypes = response.data.items;
            var region = regionTypes.find(e => e.name === "Region");
            if (region !== null && typeof region !== "undefined") {
                this.parameters[2].fields.value = region.id;
            }
        },

        data() {
            return {
                queryLoading: false,

                headers: [
                    { text: "Region", value: "region" },
                    { text: "Number of Pollinated Sites", value: "numberOfPollinatedSites" },
                    { text: "Total Number of Sites", value: "totalNumberOfSites" },
                    { text: "Pollination Density", value: "pollinationDensity" }
                ],
                items: [],
                parameters: [
                    { component: () => import('./DateParameter'), fields: { name: "From", field: "from", value: this.getFilterFromDate() } },
                    { component: () => import('./DateParameter'), fields: { name: "To", field: "to", value: this.getFilterToDate() } },
                    { component: () => import('./AutocompleteParameter'), fields: { name: "Region Type", field: "regionTypeId", value: null, apiMethod: 'RegionTypes' } }
                ],
                title: "Pollination Density Report", 

                isFormValid: false
            }
        },

        methods: {
            async runQuery() {
                this.queryLoading = true;
                try {
                    var params = {};
                    this.parameters.forEach(e => params[e.fields.field] = e.fields.value);
                    var response = await axios.get('/api/PollinationDensityReport', { params });
                    this.items = response.data;
                }
                catch (error) {
                    errorUtility.handleServerError(error);
                }
                finally {
                    this.queryLoading = false;
                }
            },
            getFilterFromDate() {
                var currentDate = new Date();
                currentDate.setMonth(currentDate.getMonth() - 1);
                return currentDate.toISOString().slice(0, 10);
            },
            getFilterToDate() {
                return DateTime.local().toISODate();
            }
        },
        watch: {
            parameters: {
                deep: true,
                handler() {
                    if (this.parameters.every(e => e.fields.value != null)) {
                        this.isFormValid = true;
                    }
                }
            }
        }
    }
</script>
